import React from 'react'
import styled from 'styled-components'
import MainCta from '../botones/main-cta'
import ImagenTarjeta from './imagen'
import Buttons from '../botones/multicanalidad'

const Container = styled.div`
  height: 100%;
  display: flex;
  flex-direction: column;

  & > div:first-of-type {
    flex: 1;
  }

  & > div:last-of-type {
    margin-top: auto;
  }

  & > a:last-of-type {
    margin-top: auto;
    align-self: flex-start;
  }

  h3 {
    margin-top: 0;
  }

  &:hover .gatsby-image-outer-wrapper {
    transform: scale(1.02);
    box-shadow: 1px 1px 8px 0 rgba(0, 0, 0, 0.4);
  }
`

const Beneficios = styled.ul`
  margin: 20px 0;
  padding-left: 18px;

  li {
    margin-bottom: 5px;
    font-size: 14px;
    color: ${props => props.theme.colors.grisOscuro};
  }
`

const Reglamento = styled.div`
  font-size: 12px;
  color: ${props => props.theme.colors.grisOscuro};
  margin: 15px 0 40px;

  a,
  a:visited,
  a:active {
    text-decoration: none;
    color: ${props => props.theme.colors.amexBlue};
  }

  a:hover {
    text-decoration: underline;
  }
`

const MainCtaButton = ({ to, countryAbr, whatsapp }) => (
  <MainCta to={to}>
    Solicit{['CRI', 'NIC'].includes(countryAbr) ? 'á' : 'a'} tu tarjeta{' '}
    {whatsapp && `por WhatsApp`}
  </MainCta>
)

export default ({ tarjeta, countryAbr, whatsapp, formUrl, multicanalidad }) => {
  const costo = tarjeta.variacion[0].tipoDeCosto
    ? `${tarjeta.variacion[0].tipoDeCosto}: ${
        tarjeta.variacion[0].monedaDeCosto
      }${tarjeta.variacion[0].costo}`
    : null
  const reglamento = tarjeta.reglamento
    ? tarjeta.reglamento
    : tarjeta.productPage

  const linkAlForm = whatsapp === true ? formUrl : tarjeta.formOpa
  return (
    <Container>
      <div>
        <h3>{tarjeta.titulo}</h3>
        <ImagenTarjeta
          link={tarjeta.productPage}
          imagen={tarjeta.variacion[0].arte.sizes}
          alt={tarjeta.titulo}
        />
        <Beneficios>
          {tarjeta.beneficiosGenerales.slice(0, 4).map(beneficio => (
            <li key={beneficio.id}>{beneficio.titulo}</li>
          ))}
          {costo && <li>{costo}</li>}
          {countryAbr === 'CRI' && (
            <li>
              <strong>
                Ingreso mínimo requerido &#8353;
                {tarjeta.variacion[0].color.salarioMinimo
                  .toFixed(2)
                  .replace(/\d(?=(\d{3})+\.)/g, '$&,')}
              </strong>
            </li>
          )}
        </Beneficios>
      </div>
      <div>
        {multicanalidad ? (
          <Buttons
            multicanalidad={multicanalidad}
            formulario={tarjeta.formOpa}
            smaller
          />
        ) : (
          <MainCtaButton
            to={linkAlForm}
            countryAbr={countryAbr}
            whatsapp={whatsapp}
          />
        )}
        <Reglamento>
          {whatsapp && (
            <p>
              También podés solicitarla{' '}
              <a href={tarjeta.formOpa}>llenando el formulario</a>
            </p>
          )}
          {countryAbr !== 'SAL' && (
            <span>
              Aplican restricciones.{' '}
              <a href={reglamento} target="_blank" rel="noopener noreferrer">
                Ver reglamento AQUÍ.
              </a>
            </span>
          )}
        </Reglamento>
      </div>
    </Container>
  )
}
